export default "__VITE_ASSET__CsM7II1c__"